export const NOTIFICATION_NAVIGATE = "noteyg:notification-navigate";
export const NOTIFICATION_READY = "noteyg:notification-ready";
export const NOTIFICATION_ACK = "noteyg:notification-ack";

export function notificationTarget(data: Record<string, unknown> = {}) {
  const rawUrl = relativeAppUrl(data.url);
  if (rawUrl && rawUrl !== "/") return normalizeLegacyUrl(rawUrl);

  const threadId = stringValue(data.threadId) || stringValue(data.sourceThreadId);
  if (threadId) {
    const messageId = stringValue(data.messageId);
    return `/chat/${encodeURIComponent(threadId)}${messageId ? `?message=${encodeURIComponent(messageId)}` : ""}`;
  }

  const noteId = stringValue(data.noteId) || stringValue(data.contextNoteId);
  if (noteId) {
    const query = new URLSearchParams();
    const actionId = stringValue(data.actionId);
    const lineIndex = finiteInteger(data.lineIndex);
    if (actionId) query.set("action", actionId);
    if (lineIndex !== null) query.set("line", String(lineIndex));
    const suffix = query.toString();
    return `/notes/${encodeURIComponent(noteId)}${suffix ? `?${suffix}` : ""}`;
  }

  const jobId = stringValue(data.jobId);
  if (jobId) return `/jobs?job=${encodeURIComponent(jobId)}`;
  if (stringValue(data.actionId)) return "/actions";
  return normalizeLegacyUrl(rawUrl || "/");
}

export function validNotificationTarget(value: unknown) {
  return typeof value === "string" && value.startsWith("/") && !value.startsWith("//") && !value.includes("\\");
}

function normalizeLegacyUrl(value: string) {
  if (value === "/app") return "/";
  if (value.startsWith("/app/")) return value.slice(4) || "/";
  return value;
}

function relativeAppUrl(value: unknown) {
  return validNotificationTarget(value) ? String(value) : "";
}

function stringValue(value: unknown) {
  return typeof value === "string" && value.trim() ? value.trim() : "";
}

function finiteInteger(value: unknown) {
  if (value === "" || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isInteger(number) && number >= 0 ? number : null;
}
